var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/welcome1.021322b7.png","uri@2x": __webpack_public_path__ + "static/media/welcome1.cf7b853b.png","uri@3x": __webpack_public_path__ + "static/media/welcome1.f4d65924.png",
    width: 179,
    height: 178
});